import {defineMessages} from 'react-intl';

export default defineMessages({
	filter: {
		id: 'plp.refinements.filter',
		defaultMessage: 'Filters {count, plural, =0 {} other {({count})}}',
	},
});
